
import { CheckCircle2 } from "lucide-react";

interface PremiumAdvantagesProps {
  advantages: string[];
}

const PremiumAdvantages = ({ advantages }: PremiumAdvantagesProps) => {
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-4 text-[#243949]">What is METRADE Premium?</h2>
      <div className="bg-[#E7F0FD] rounded-lg p-6 mb-6">
        <ul className="space-y-4">
          {advantages.map((advantage, index) => (
            <li key={index} className="flex items-start gap-3">
              <CheckCircle2 className="w-5 h-5 text-[#517FA4] mt-0.5 flex-shrink-0" />
              <span className="text-[#243949] font-bold">{advantage}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PremiumAdvantages;
